// extracted by mini-css-extract-plugin
module.exports = {"footer":"StaffForm_footer_2IiKV"};